import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Structura Food Market ya no es el sitio comercial de la plataforma.
 * La venta, pricing y adquisición viven en https://structura.com.ar/.
 * La entrada pública de FM queda reservada al acceso del comercio.
 */
export const Route = createFileRoute("/")({
  beforeLoad: () => {
    throw redirect({ to: "/acceso/comercio", statusCode: 302 });
  },
});
